import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import Timeline from "../OrgStructure/Timeline";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";

function KeyExpansionsAndStrategicInitiatives({
  keyExpansionsStrategicInitiatives,
}) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const [timelineData, setTimelineData] = useState(null);

  const allMetrics = [
    { key: "year_initiated", label: "Year Initiated" },
    { key: "strategic_initiative", label: "Development" },
    { key: "description", label: "Description" },
    { key: "focus_area", label: "Focus area / strategic significance" },
    // { key: "market", label: "Market" },
  ];

  const dummyData = [
    {
      strategic_initiative: {
        value: "European Market Entry",
      },
      description: {
        value:
          "Geographic expansion through direct sales offices and distributor partnerships to penetrate regional markets",
      },
      market: {
        value: "European Adhesives",
      },
      focus_area: {
        value: "Geographic expansion, distribution partnerships",
      },
      year_initiated: {
        value: "2023",
      },
    },
  ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(
      keyExpansionsStrategicInitiatives
    );
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   keyExpansionsStrategicInitiatives?.[0]?.response?.["tableComments"]
      // )
      <ParsedTextWithLinks
        text={
          keyExpansionsStrategicInitiatives?.[0]?.response?.["tableComments"] ||
          ""
        }
      />
    );

    const tempTimelineData = transformed.map((timeline) => {
      return {
        date: timeline?.year_initiated?.value || "",
        title: {
          value: timeline?.strategic_initiative?.value || "",
          source: timeline?.strategic_initiative?.source || "",
          confidence_score:
            timeline?.strategic_initiative?.confidence_score || "",
          reasoning: timeline?.strategic_initiative?.reasoning || "",
        },
        description: {
          value: timeline?.description?.value || "",
          source: timeline?.description?.source || "",
          confidence_score: timeline?.description?.confidence_score || "",
          reasoning: timeline?.description?.reasoning || "",
        },
        category: {
          value: timeline?.focus_area?.value || "",
          source: timeline?.focus_area?.source || "",
          confidence_score: timeline?.focus_area?.confidence_score || "",
          reasoning: timeline?.focus_area?.reasoning || "",
        },
      };
    });
    setTimelineData(tempTimelineData);
    // console.log("TIMELINE: " + JSON.stringify(timelineData));
  }, [keyExpansionsStrategicInitiatives]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <>
      {!timelineData?.length ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <div className="table_head_block d-block">
          <div className="table_subblock_left">
            <h5 className="table_head">
              Key Expansions & Strategic Initiatives
            </h5>
            <Timeline
              data={timelineData}
              filterColumn={[]}
              from="Key Expansions & Strategic Initiatives"
            />
          </div>
        </div>
      )}

      {/* <InsightTable
        title="Key Expansions & Strategic Initiatives"
        subtitle=""
        // belowTableDescription={`The desperation behind the expansion spree: Taylor's expansion strategy reveals a company under serious pressure to diversify, and the timeline tells a story of urgency [7]. European expansion (2023 [7]), Healthcare specialization (2022 [7]), Sustainability leadership (2024 [7]), and Digital platforms (2023 [7]) - four major initiatives in just three years. They're moving into healthcare and digital platforms precisely because their core commercial flooring market is maturing and they know it. Here's what H.B. Fuller should really note: Taylor's European expansion timing coincides with supply chain disruptions, suggesting opportunistic market entry rather than strategic strength. Their digital platform investment? That's them admitting their traditional relationship-based sales model is becoming outdated.`}
        belowTableDescription={tableBelowDescription}
        data={tabData}
        metrics={allMetrics}
        // rowIdentifier="strategic_initiative"
        rowIdentifier={[]}
        actions={actions}
      /> */}
    </>
  );
}

export default KeyExpansionsAndStrategicInitiatives;
